import { Card, Inline, Skeleton, Stack, breakpoints, vars } from '@etg/wings';
import { css, cx } from '@eti/styles';

const boundsSectionStyles = css`
  padding: 16px;

  @media (min-width: ${breakpoints._768}) {
    width: 75%;
  }
`;

const ctaSectionStyles = css`
  align-items: center;
  border-top: 1px solid ${vars.colors.divider};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 16px;

  @media (min-width: ${breakpoints._768}) {
    align-items: end;
    border-inline-start: 1px solid ${vars.colors.divider};
    border-top: 0;
    flex-direction: column;
    width: 25%;
  }
`;

const flightBadgeSkeleton = css`
  width: 25%;
`;

const boundsSkeletonHeight = css`
  height: 24px;
`;

const ctaSkeleton = css`
  height: 48px;
  margin-inline-start: auto;
  width: 40%;

  @media (min-width: ${breakpoints._768}) {
    margin-top: auto;
    width: 100%;
  }
`;

const baggageInfoSkeleton = css`
  height: 32px;
  width: 25%;

  @media (min-width: ${breakpoints._768}) {
    width: 50%;
  }
`;

const FlightResultSkeleton = () => (
  <Card padding={0}>
    <Inline collapseBelow={breakpoints._768} spacing={0}>
      <div className={boundsSectionStyles}>
        <Stack spacing={24}>
          <Skeleton className={cx(flightBadgeSkeleton, boundsSkeletonHeight)} />
          <Stack spacing={8}>
            <Skeleton className={boundsSkeletonHeight} />
            <Skeleton className={boundsSkeletonHeight} />
          </Stack>
          <Stack spacing={8}>
            <Skeleton className={boundsSkeletonHeight} />
            <Skeleton className={boundsSkeletonHeight} />
          </Stack>
        </Stack>
      </div>
      <div className={ctaSectionStyles}>
        <Skeleton className={baggageInfoSkeleton} />
        <Skeleton className={ctaSkeleton} />
      </div>
    </Inline>
  </Card>
);

export default FlightResultSkeleton;
